export default __webpack_public_path__ + "static/media/polestar-car.fc794e6e.png";